import React, { useState } from 'react';

const ContactPickerDemo = () => {
    const [contacts, setContacts] = useState([]);
    const [error, setError] = useState("");

    const handlePickContacts = async () => {
        setError(""); // Clear previous errors

        // 1. Check if the browser supports the Contact Picker API
        const isSupported = ('contacts' in navigator && 'ContactsManager' in window);
        
        if (!isSupported) {
            setError("⚠️ Your current browser or device does not support the Contact Picker API. Please try on an Android (Chrome) or iOS (Safari) mobile device.");
            return;
        }

        try {
            // 2. Define what information we want to extract
            const properties = ['name', 'tel'];
            
            // 3. Allow multiple selections
            const options = { multiple: true };
            
            // 4. Open the native phonebook UI
            const selectedContacts = await navigator.contacts.select(properties, options);
            
            // 5. Save the selected contacts to our state
            if (selectedContacts.length > 0) {
                setContacts(selectedContacts);
            }
        } catch (err) {
            console.error("Error picking contacts:", err);
            setError("Action cancelled or failed to retrieve contacts.");
        }
    };

    return (
        <div className="app-container p-4" style={{ backgroundColor: '#f8fafc', minHeight: '100vh', fontFamily: 'sans-serif' }}>
            
            <div style={{ maxWidth: '600px', margin: '0 auto', backgroundColor: 'white', padding: '24px', borderRadius: '16px', boxShadow: '0 4px 6px rgba(0,0,0,0.05)' }}>
                <h2 style={{ margin: '0 0 8px 0', color: '#0f172a' }}>📱 Phonebook Access Demo</h2>
                <p style={{ color: '#64748b', fontSize: '14px', marginBottom: '24px' }}>
                    Click the button below to open your native phonebook. Select a few contacts to import them into this page.
                </p>

                <button 
                    onClick={handlePickContacts}
                    style={{
                        backgroundColor: '#2563eb',
                        color: 'white',
                        padding: '12px 24px',
                        border: 'none',
                        borderRadius: '12px',
                        fontSize: '16px',
                        fontWeight: '600',
                        cursor: 'pointer',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px',
                        width: '100%',
                        justifyContent: 'center',
                        boxShadow: '0 4px 6px rgba(37, 99, 235, 0.2)'
                    }}
                >
                    <svg width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                        <circle cx="9" cy="7" r="4"></circle>
                        <path strokeLinecap="round" strokeLinejoin="round" d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
                        <path strokeLinecap="round" strokeLinejoin="round" d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                    </svg>
                    Open Phonebook
                </button>

                {/* Error Message Display */}
                {error && (
                    <div style={{ marginTop: '20px', padding: '12px', backgroundColor: '#fef2f2', color: '#ef4444', borderRadius: '8px', fontSize: '14px' }}>
                        {error}
                    </div>
                )}

                {/* Selected Contacts List */}
                {contacts.length > 0 && (
                    <div style={{ marginTop: '32px' }}>
                        <h3 style={{ fontSize: '16px', color: '#1e293b', borderBottom: '2px solid #e2e8f0', paddingBottom: '8px' }}>
                            Selected Contacts ({contacts.length})
                        </h3>
                        
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', marginTop: '16px' }}>
                            {contacts.map((contact, index) => {
                                // The API returns arrays for names and phones, so we grab the first item [0]
                                const name = contact.name ? contact.name[0] : 'No Name';
                                const phone = contact.tel ? contact.tel[0] : 'No Number';

                                return (
                                    <div key={index} style={{ display: 'flex', alignItems: 'center', gap: '12px', padding: '12px', backgroundColor: '#f8fafc', borderRadius: '12px', border: '1px solid #e2e8f0' }}>
                                        <div style={{ width: '40px', height: '40px', borderRadius: '50%', backgroundColor: '#dbeafe', color: '#2563eb', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 'bold', fontSize: '16px' }}>
                                            {name.charAt(0).toUpperCase()}
                                        </div>
                                        <div>
                                            <div style={{ fontWeight: '600', color: '#0f172a', fontSize: '15px' }}>{name}</div>
                                            <div style={{ color: '#64748b', fontSize: '13px', marginTop: '2px' }}>{phone}</div>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                )}
            </div>

        </div>
    );
};

export default ContactPickerDemo;